/**
 * @namespace Foundation development tools.
 */
Foundation.Dev = {};
window["Foundation"]["Dev"] = {};

/**
 * Returns true when in automated testing mode. This is useful for 
 * ensuring values which interfere with automated testing (like
 * current date and time, or a random number) are normalized.
 * @return {boolean}
 */
Foundation.Dev.isTestingMode = function () {
    return !!Foundation.Dev._testingMode;
};

/**
 * Used by automated tests to set testing mode.
 * @param {boolean} testingMode
 */
Foundation.Dev.setTestingMode = function (testingMode) {
    Foundation.Dev._testingMode = testingMode;
};

/**
 * Are we on an admin page?
 * @returns {boolean}
 */
Foundation.Dev.pageIsAdmin = function () {
    return !!document.domain.match(/^(a\.|admin\.)|\.foundation\.gyrobase\.com$/);
};

/**
 * Log an event to the server.
 * @param {string} eventName
 * @param {Object.<string,*>} data
 */
Foundation.Dev.logEvent = function (eventName, data) {
    var dataString = JSON.stringify(data)
    var stackTrace = (new Error()).stack || null
    new Foundation.API("POST", "Dev/Event", {
        "name": eventName,
        "data": dataString,
        "stack": stackTrace
    })
}

/**
 * Switch between debugable core JS file and the compiled core JS file.
 */
Foundation.Dev.toggleDebugJS = function () {
    var url = Foundation.URL.fromCurrentLocation();
    
    if (Foundation.Dev.pageIsAdmin()) {
        // Use cookies for admin.
        var cookie = new Foundation.Cookie("foundation-debugjs");
        if (cookie.getValue()) {
            cookie.erase();
        }
        else {
            cookie.setValueAndSave("1");
        }
    }
    else {
        // Use URL parameter for public site, to avoid getting uncompiled
        // JS file URLs in the proxy cache.
        if (url.get("debugjs")) {
            url.unset("debugjs");
        }
        else {
            url.set("debugjs", 1);
        }
    }
    
    // Reload the page.
    url.go();
};

/**
 * Are we in Debug JS mode?
 * @return {boolean}
 */
Foundation.Dev.isDebugJSActive = function () {
    return !!(jQuery('head script[src*="core-"][src*="-debug.js"]').length);
};

/**
 * Show a badge when in Debug JS mode. We run this on DOM ready.
 */
Foundation.Dev.showDebugJSBadge = function () {
    if (Foundation.Dev.isDebugJSActive()) {
        jQuery('<div>Core JS debug mode is ON</div>')
            .css({
                "position": "fixed",
                "top": "4px",
                "right": "4px",
                "z-index": "100000",
                "color": "#C02D32",
                "font-family": "arial",
                "font-weight": "bold",
                "font-size": "16px",
                "border": "2px solid #D6D6D6",
                "padding": "2px",
                "background": "#F3F3F3",
                "cursor": "pointer"
            })
            .attr("title", "Click to turn off")
            .click(Foundation.Dev.toggleDebugJS)
            .appendTo(document.body);
    }
};
Foundation.documentReady.then(Foundation.Dev.showDebugJSBadge);

// ---------------------------------------------------------------------

window["Foundation"]["Dev"]["toggleDebugJS"] = Foundation.Dev.toggleDebugJS;
window["Foundation"]["Dev"]["setTestingMode"] = Foundation.Dev.setTestingMode;
window["Foundation"]["Dev"]["isDebugJSActive"] = Foundation.Dev.isDebugJSActive;
window["Foundation"]["Dev"]["logEvent"] = Foundation.Dev.logEvent;
